export default __webpack_public_path__ + "static/media/google_sheet.028f96ac.PNG";